var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2892 7.54604H7.33206L7.64634 5.18889H5.2892V3.85318C5.2892 3.14604 5.44634 2.67461 6.46777 2.67461H7.64634V0.553181C7.41063 0.553181 6.86063 0.474609 5.99634 0.474609C4.1892 0.474609 2.93206 1.57461 2.93206 3.61747V5.18889H0.967773V7.54604H2.93206V13.8318H5.2892V7.54604Z",
    fill: "#DEE965"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.4d96eefe10206bda415f51964a6feb2a.svg";
export { ForwardRef as ReactComponent };